import { useL10n } from "@ews/react-localization-context";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";

const SystemOperator: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();
    return <>
        <SettingsTextInput
            text={t("TRVB_NAME_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_NAME_LABEL")} />}
            inputType={"text"}
            value={specification.systemOperator?.name}
            onBlur={({ value }) =>
            {
                if (specification.systemOperator?.name === value) return;
                if (systemId && specification.systemOperator) {

                    const { address, telephoneNumber, email } = specification.systemOperator;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemOperator: {
                            name: value,
                            address,
                            telephoneNumber,
                            email
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={t("TRVB_ADDRESS_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_ADDRESS_DESC")} />}
            inputType={"text"}
            value={specification.systemOperator?.address}
            onBlur={({ value }) =>
            {
                if (specification.systemOperator?.address === value) return;
                if (systemId && specification.systemOperator) {
                    const { name, telephoneNumber, email } = specification.systemOperator;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemOperator: {
                            address: value,
                            name,
                            telephoneNumber,
                            email
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={t("TRVB_TEL_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_TEL_LABEL")} />}
            inputType={"tel"}
            value={specification.systemOperator?.telephoneNumber}
            onBlur={({ value }) =>
            {
                if (specification.systemOperator?.telephoneNumber === value) return;
                if (systemId && specification.systemOperator) {
                    const { address, email, name } = specification.systemOperator;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemOperator: {
                            telephoneNumber: value,
                            address,
                            name,
                            email
                        },
                    });
                }
            }
            } />

        <SettingsTextInput
            text={t("TRVB_MAIL_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_MAIL_LABEL")} />}
            inputType={"email"}
            value={specification.systemOperator?.email}
            onBlur={({ value }) =>
            {
                if (specification.systemOperator?.email === value) return;
                if (systemId && specification.systemOperator) {
                    const { address, telephoneNumber, name } = specification.systemOperator;
                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemOperator: {
                            email: value,
                            address,
                            telephoneNumber,
                            name
                        },
                    });
                }
            }
            } />
    </>;
};

export default SystemOperator;
